import { render, staticRenderFns } from "./global-header.vue?vue&type=template&id=618d8f9e&scoped=true"
import script from "./global-header.vue?vue&type=script&lang=js"
export * from "./global-header.vue?vue&type=script&lang=js"
import style0 from "./global-header.vue?vue&type=style&index=0&id=618d8f9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d8f9e",
  null
  
)

export default component.exports